export default {
  data: {
    high_water_mark: null,
    drawdown_high_water_mark: null,
    annualized_volatility: null,
    sharpe_ratio: null,
  },
};
